import "./MainNavigation/main-navigation";

// Select the navigation bar
const header = document.querySelector<HTMLElement>("#site-header");

const mobileMenuToggle = document.querySelector<HTMLButtonElement>(
  "[aria-controls*='mobile-menu'"
);

if (header) {
  let isFlyoutOpen = false;

  const hasTransparentFeature = header.dataset.supportsTransparency === "true";
  let isTransparent = header.dataset.isTransparent === "true";

  let lastScrollY = window.scrollY;
  let isVisible = true;

  const handleScroll = () => {
    if (isFlyoutOpen) {
      // While any flyout is open, don't hide the header or change transparency.
      return;
    }

    const currentScrollY = window.scrollY;
    const headerSlotHeight = header.clientHeight;
    const scrolledPastThreshold = currentScrollY > headerSlotHeight;

    // Handle position based on scroll direction.
    // Allow scrolling down a little bit (no matter where on the page) before hiding the header.
    if (scrolledPastThreshold && currentScrollY > lastScrollY) {
      if (isVisible) {
        header.classList.add("-translate-y-full");
        isVisible = false;
      }
    } else if (currentScrollY < lastScrollY) {
      if (!isVisible) {
        header.classList.remove("-translate-y-full");
        isVisible = true;
      }
    }

    setScrolledColor(currentScrollY > 0);

    lastScrollY = currentScrollY;
  };

  const setScrolledColor = (makeSolid: boolean) => {
    if (hasTransparentFeature && isTransparent === makeSolid) {
      isTransparent = !makeSolid;
      header.dataset.isTransparent = isTransparent.toString();
    }
  };

  window.addEventListener("scroll", handleScroll, { passive: true });
  header.addEventListener("flyout:open", () => {
    setScrolledColor(true);
    isFlyoutOpen = true;
  });
  header.addEventListener("flyout:close", () => {
    setScrolledColor(window.scrollY > 0);
    isFlyoutOpen = false;
  });

  // Update transparency on initial load, to ensure correct state
  // when the page is loaded at a scroll position other than the top.
  setScrolledColor(window.scrollY > 0);
}
